export interface YearMonthDay {
  year: number;
  month: number;
  day: number;
}

export default function yearMonthDay(date: Date): YearMonthDay {
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();

  return { year, month, day };
}

export const OccurrenceMap = {
  0: 0,
  1: 6,
  2: 5,
  3: 4,
  4: 3,
  5: 2,
  6: 1,
};
